/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { find, cloneDeep } from 'lodash';
import moment from 'moment';
import * as queryString from 'querystring';

const _ = { find, cloneDeep };

export const playerTypes = {
    WINNER: 'winner',
    LOSER: 'loser',
};

export const eventDirectorRoles = {
    HEAD_ORGANIZER: 2,
    ORGANIZER: 1,
};

export function removeQueryParam(param, props) {
    const params = queryString.parse(props.location.search);
    delete params[param];
    props.history.push({
        pathname: props.location.pathname,
        search: queryString.stringify(params),
    });
}

export function getFlagUrl(countryCode) {
    if (countryCode) {
        return `/img/flags/${countryCode.toLowerCase()}.svg`;
    }
    return '';
}

export function getPlayerName(firstName, lastName, shortenFirstName) {
    let firstCharacter = '';

    if (firstName && firstName.length > 0) {
        if (shortenFirstName) {
            firstCharacter = `${firstName.charAt(0)}.`;
        } else {
            firstCharacter = firstName;
        }
    }

    if (lastName && lastName.length > 0) {
        return `${firstCharacter} ${lastName}`;
    }
    return firstCharacter;
}

export function formatPlayerShots(dominantHand, backHand) {
    let shots = '';

    if (dominantHand !== null) {
        shots += dominantHand;
    }
    if (backHand !== null) {
        if (shots.length !== 0) {
            shots += ', ';
        }
        shots += `${backHand} Backhand`;
    }

    return shots.length > 0 ? shots : '--';
}

export function getThirdPartyRanking(thirdPartyRankings, rankingSource) {
    const ranking = _.find(thirdPartyRankings, (r) => {
        // has rank with published date in the past 3 weeks
        return r.source === rankingSource && moment(r.publishedDate).isAfter(moment().subtract(21, 'd'));
    });
    return ranking ? `#${ranking.rank}` : `Former ${rankingSource} Ranked Player`;
}

export function getExtendedRatingAndRank(extendedRatingProfile, type, showOnly) {
    const ratingType = type || 'threeMonth';
    const rankingType = `${ratingType}Rank`;

    let rating = '';
    let ranking = '';
    if (extendedRatingProfile && extendedRatingProfile.ratings !== null && extendedRatingProfile.ratings[`${ratingType}`] !== null) {
        rating = `${extendedRatingProfile.ratings[`${ratingType}`]}`;
    }
    if (extendedRatingProfile && extendedRatingProfile.rankings !== null && extendedRatingProfile.rankings[`${rankingType}`] !== null) {
        ranking = `Rank ${extendedRatingProfile.rankings[`${rankingType}`]}`;
    }
    switch (showOnly) {
        case 'rating':
            return rating;
        case 'rank':
            return ranking;
        default:
            return `${rating}${(rating.length > 0 && ranking.length > 0) ? ' (' : ''}${ranking}${(rating.length > 0 && ranking.length > 0) ? ')' : ''}`;
    }
}

export function wonGame(players, playerId) {
    // console.log('wonGame', players, playerId)
    if (players.winner1.id == playerId) {
        return true;
    } if (players.winner2 != undefined && players.winner2.id == playerId) {
        return true;
    }
    return false;
}

export const wonSet = (score, playerType) => {
    switch (playerType) {
        case playerTypes.WINNER:
            return score.winner > score.loser;
        case playerTypes.LOSER:
            return score.loser > score.winner;
        default:
            return false;
    }
};

export const tieBreakScore = (score, playerType) => {
    const superTieBreaker = score.winner === 1 && score.loser === 0;
    const won = wonSet(score, playerType);
    if (superTieBreaker) {
        return won ? score.tiebreak < 9 ? 10 : score.tiebreak + 2 : score.tiebreak;
    }
    return won ? score.tiebreak < 6 ? 7 : score.tiebreak + 2 : score.tiebreak;
};

export const countWords = (string) => {
    string = string.replace(/(^\s*)|(\s*$)/gi, '');// exclude  start and end white-space
    string = string.replace(/[ ]{2,}/gi, ' ');// 2 or more space to 1
    string = string.replace(/\n /, '\n'); // exclude newline with a start spacing
    return string.split(' ').filter((str) => {
        return str !== '';
    }).length;
    // return s.split(' ').filter(String).length; - this can also be used
};

export const truncateString = (string, noOfWords) => {
    if (!noOfWords) {
        return string;
    }
    string = string.trim().split(' ');
    return string.splice(0, noOfWords).join(' ');
};

export const playerSortOptions = [
    {
        label: 'Singles UTR & Status',
        value: 1,
        sortParams: [
            {
                sortVariable: 'ratingStatusSingles',
                sortAsc: false,
            },
            {
                sortVariable: 'singlesUtr',
                sortAsc: false,
            },
        ],
    },
    {
        label: 'Singles UTR',
        value: 2,
        sortParams: [
            {
                sortVariable: 'singlesUtr',
                sortAsc: false,
            },
        ],
    },
    {
        label: 'Doubles UTR & Status',
        value: 3,
        sortParams: [
            {
                sortVariable: 'ratingStatusDoubles',
                sortAsc: false,
            },
            {
                sortVariable: 'doublesUtr',
                sortAsc: false,
            },
        ],
    },
    {
        label: 'Doubles UTR',
        value: 4,
        sortParams: [
            {
                sortVariable: 'doublesUtr',
                sortAsc: false,
            },
        ],
    },
    {
        label: 'First Name',
        value: 5,
        sortParams: [
            {
                sortVariable: 'firstName',
                sortAsc: true,
            },
        ],
    },
    {
        label: 'Last Name',
        value: 6,
        sortParams: [
            {
                sortVariable: 'lastName',
                sortAsc: true,
            },
        ],
    },
];

export const schoolSortOptions = [
    {
        label: 'Power 6',
        value: 1,
        sortParams: [
            {
                sortVariable: 'power6',
                sortAsc: false,
            },
        ],
    },
    {
        label: 'Name',
        value: 2,
        sortParams: [
            {
                sortVariable: 'displayName',
                sortAsc: true,
            },
        ],
    },
];

export const ratingStatuses = [
    {
        label: 'Rated',
        value: 3,
    },
    {
        label: 'Projected',
        value: 2,
    },
    {
        label: 'Inactive',
        value: 1,
    },
    {
        label: 'Unrated',
        value: 0,
    },
];

export const updateRatingObject = ({ player, ratingType, utrType }) => {
    // console.log('updateRatingObject', player, ratingType, utrType);

    const unDisplayedStatusStatus = ['Inactive', 'Unrated'];
    const newRatingObject = player ? _.cloneDeep(player) : {};

    // force singles or doubles return
    if (ratingType && utrType) {
        if (ratingType == 'singles') {
            if (utrType == 'sanctioned') {
                newRatingObject.ratingChoice = 'VerifiedSinglesUTR';
            } else {
                newRatingObject.ratingChoice = 'SinglesUTR';
            }
        } else if (utrType == 'sanctioned') {
            newRatingObject.ratingChoice = 'VerifiedDoublesUTR';
        } else {
            newRatingObject.ratingChoice = 'DoublesUTR';
        }
    } else if (ratingType) {
        // only return singles value
        if (ratingType == 'singles') {
            if (player.singlesUtr && (player.singlesUtr > 0) && !unDisplayedStatusStatus.includes(player.ratingStatusSingles)) {
                newRatingObject.ratingChoice = 'VerifiedSinglesUTR';
            } else {
                newRatingObject.ratingChoice = 'SinglesUTR';
            }
        // only return doubles value
        } else if (player.doublesUtr && (player.doublesUtr > 0) && !unDisplayedStatusStatus.includes(player.ratingStatusDoubles)) {
            newRatingObject.ratingChoice = 'VerifiedDoublesUTR';
        } else {
            newRatingObject.ratingChoice = 'DoublesUTR';
        }
    } else if (utrType) {
        // only return verified rating
        if (utrType == 'sanctioned') {
            if (player.singlesUtr && (player.singlesUtr > 0) && !unDisplayedStatusStatus.includes(player.ratingStatusSingles)) {
                newRatingObject.ratingChoice = 'VerifiedSinglesUTR';
            } else if (player.doublesUtr && (player.doublesUtr > 0) && !unDisplayedStatusStatus.includes(player.ratingStatusDoubles)) {
                newRatingObject.ratingChoice = 'VerifiedDoublesUTR';
            } else {
                newRatingObject.ratingChoice = 'VerifiedSinglesUTR';
                if (player.singlesUtr && player.singlesUtr > 0 && player.ratingStatusSingles === 'Inactive') {
                    // Do nothing since we need to show inactive rating for verified singles
                } else {
                    // SHow Unrated
                    newRatingObject.ratingStatusSingles = 'Unrated';
                    newRatingObject.singlesUtr = 0;
                }
            }
        // only return unverified rating
        } else if (player.myUtrSingles && (player.myUtrSingles > 0) && !unDisplayedStatusStatus.includes(player.myUtrStatusSingles)) {
            newRatingObject.ratingChoice = 'SinglesUTR';
        } else if (player.myUtrDoubles && (player.myUtrDoubles > 0) && !unDisplayedStatusStatus.includes(player.myUtrStatusDoubles)) {
            newRatingObject.ratingChoice = 'DoublesUTR';
        } else {
            newRatingObject.ratingChoice = 'SinglesUTR';
            if (player.myUtrSingles && player.myUtrSingles > 0 && player.myUtrStatusSingles === 'Inactive') {
                // Do nothing since we need to show inactive rating for singles
            } else {
                // SHow Unrated
                newRatingObject.myUtrStatusSingles = 'Unrated';
                newRatingObject.myUtrSingles = 0;
            }
        }

    // return the most relevant rating (any)
    // if there is no forced display, use player perference
    } else if (player.ratingChoice) {
        // If there is a reating choice no updation needed

        // otherwise show Rated or Projected rating if exists in the priority order of verifiedSingles, verifiedDoubles, myutrSingles and myUtrDoubles
        /*
            Checking with statuses of 'Inactive' and 'Unrated' since status null condition with a rating should be treated as Projected rating in getRatingDetails Method
            */
    } else if (player.singlesUtr && (player.singlesUtr > 0) && !unDisplayedStatusStatus.includes(player.ratingStatusSingles)) {
        newRatingObject.ratingChoice = 'VerifiedSinglesUTR';
    } else if (player.doublesUtr && (player.doublesUtr > 0) && !unDisplayedStatusStatus.includes(player.ratingStatusDoubles)) {
        newRatingObject.ratingChoice = 'VerifiedDoublesUTR';
    } else if (player.myUtrSingles && (player.myUtrSingles > 0) && !unDisplayedStatusStatus.includes(player.myUtrStatusSingles)) {
        newRatingObject.ratingChoice = 'SinglesUTR';
    } else if (player.myUtrDoubles && (player.myUtrDoubles > 0) && !unDisplayedStatusStatus.includes(player.myUtrStatusDoubles)) {
        newRatingObject.ratingChoice = 'DoublesUTR';
    } else {
        newRatingObject.ratingChoice = 'SinglesUTR';
        if (player.myUtrSingles && player.myUtrSingles > 0 && player.myUtrStatusSingles === 'Inactive') {
            // Do nothing since we need to show inactive rating for singles
        } else {
            // SHow Unrated
            newRatingObject.myUtrStatusSingles = 'Unrated';
            newRatingObject.myUtrSingles = 0;
        }
    }
    return newRatingObject;
};

const getRatingStatus = (ratingStatus, ratingValue) => {
    const ratedStrings = ['Projected', 'Inactive', 'Rated'];
    if (ratingValue && ratingValue > 0 && ratedStrings.includes(ratingStatus)) {
        return ratingStatus;
    }
    /*
         If rating is 0 even though the rating status is available make it unrated
         and rating status is unrated consider it as unrated and then check for projected status if rating exists
         */
    if (ratingValue && ratingValue > 0) {
        // If unrated and there is a rating condider the rating to be projected
        return 'Projected';
    }
    return 'Unrated';
};

/*
Progress should be made 0 in case of status Unrated and a rating value exists
 */
const getRatingProgress = (ratingStatus, ratingValue, ratingProgress) => {
    const ratedStrings = ['Projected', 'Inactive', 'Rated'];
    if (ratingValue && ratingValue > 0 && ratedStrings.includes(ratingStatus)) {
        return ratingProgress;
    }
    if (ratingValue && ratingValue > 0) {
        return 0;
    }
    return ratingProgress;
};

export const ratingStatusPopUpData = {
    rated: {
        title: 'Established Rating',
        description: 'This player has played enough matches for their rating to be reliable. It usually takes 6-10 matches to get a reliable rating, depending on the reliability of your opponent and how close the score was.',
    },
    unrated: {
        title: 'Unrated',
        description: 'This player has not played any matches or had a rating in the past year.',
    },
    inactive: {
        title: 'Inactive Rating',
        description: 'This player has not played any matches in the past 12 months. Their rating is the last time they had a rating on UTR.',
    },
    projected: {
        title: 'Projected Rating',
        description: 'This player hasn’t played enough matches in the last 12 months for their rating to be reliable.  It usually takes 6-10 matches to get a reliable rating, depending on the reliability of your opponent and how close the score was.  As the player plays more matches, the grey reliability bar will fill up around the projected rating.  Once it is full, the rating will become reliable and turn from grey to a colored circle.',
    },
};

export const getRatingDetails = (rating, userIsPowered, showDecimals) => {
    const object = {};
    let utrValue;
    let verifiedRating = false;

    switch (rating.ratingChoice) {
        case 'SinglesUTR':
            utrValue = rating.myUtrSingles;
            object.status = getRatingStatus(rating.myUtrStatusSingles, rating.myUtrSingles);
            object.matchType = 'singles';
            object.sortValue = (object.status === 'Rated') ? 3 : 2;
            object.progress = getRatingProgress(rating.myUtrStatusSingles, rating.myUtrSingles, rating.myUtrProgressSingles);
            break;
        case 'DoublesUTR':
            utrValue = rating.myUtrDoubles;
            object.status = getRatingStatus(rating.myUtrStatusDoubles, rating.myUtrDoubles);
            object.matchType = 'doubles';
            object.sortValue = (object.status === 'Rated') ? 3 : 2;
            object.progress = getRatingProgress(rating.myUtrStatusDoubles, rating.myUtrDoubles, rating.myUtrProgressDoubles);
            break;
        case 'VerifiedDoublesUTR':
            utrValue = rating.doublesUtr;
            object.status = getRatingStatus(rating.ratingStatusDoubles, rating.doublesUtr);
            verifiedRating = true;
            object.matchType = 'doubles';
            object.sortValue = (object.status === 'Rated') ? 5 : 4;
            object.progress = getRatingProgress(rating.ratingStatusDoubles, rating.doublesUtr, rating.ratingProgressDoubles);
            break;
        default:
            utrValue = rating.singlesUtr;
            object.status = getRatingStatus(rating.ratingStatusSingles, rating.singlesUtr);
            verifiedRating = true;
            object.matchType = 'singles';
            object.sortValue = (object.status === 'Rated') ? 5 : 4;
            object.progress = getRatingProgress(rating.ratingStatusSingles, rating.singlesUtr, rating.ratingProgressSingles);
            break;
    }
    if (utrValue && typeof utrValue === 'string') {
        utrValue = parseFloat(utrValue);
    }

    // Text to display what kind of a Rating it is
    if (object.status === 'Projected') {
        object.utrType = 'UTR (P)';
    } else {
        object.utrType = 'UTR';
    }

    // Title text i.e text displayed on Hover
    if (object.status === 'Projected') {
        object.title = 'Projected';
    }

    object.actualValue = utrValue;
    // Display UR for all Unrated conditions
    if (!utrValue || utrValue === 0 || object.status === 'Unrated') {
        object.value = 'UR';
        object.sortValue = 1;
    } else {
        object.value = `${utrValue.toFixed(2)}`;
        if (userIsPowered || showDecimals) {
            object.value = `${utrValue.toFixed(2)}`;
        } else {
            object.value = `${Math.round(utrValue)}`;
        }
    }

    // Get number value of rating
    if (object.value !== 'UR') {
        object.ratingNumber = `${parseInt(object.value)}`;
    } else {
        object.ratingNumber = object.value;
    }

    // Get Decimal value of rating
    const ratingArray = object.value.split('.');
    if (ratingArray.length > 1) {
        [, object.ratingDecimal] = ratingArray;
    } else {
        object.ratingDecimal = '';
    }

    // Logic to show verified match icon
    object.verified = verifiedRating;

    // Info PopUp Data
    object.infoTitle = ratingStatusPopUpData[object.status.toLowerCase()].title;
    object.infoDescription = ratingStatusPopUpData[object.status.toLowerCase()].description;

    return object;
};

export const getUtrRatingDisplay = (profileData, subscriptionType, type) => {
    let ratingString = 'UR';
    const utrRatingStatuses = ['Rated', 'Projected'];

    if (type === 'singles') {
        if (utrRatingStatuses.indexOf(profileData.ratingStatusSingles) !== -1) {
            // UR if rating is 0
            if (!parseInt(profileData.singlesUtr) === 0) {
                switch (subscriptionType) {
                    case 'Free':
                        ratingString = `${profileData.singlesUtr}`;
                        break;
                    default:
                        ratingString = `${profileData.singlesUtr.toFixed(2)}`;
                        break;
                }
                if (profileData.ratingStatusSingles === 'Projected') {
                    ratingString += ' (P)';
                }
            }
        } else if (profileData.myUtrSingles > 0) {
            ratingString = `${profileData.myUtrSingles.toFixed(1)}`;
        }
    } else if (type === 'doubles') {
        if (utrRatingStatuses.indexOf(profileData.ratingStatusDoubles) !== -1) {
            // UR if rating is 0
            if (!parseInt(profileData.doublesUtr === 0)) {
                switch (subscriptionType) {
                    case 'Free':
                        ratingString = `${profileData.doublesUtr}`;
                        break;
                    default:
                        ratingString = `${profileData.doublesUtr.toFixed(2)}`;
                        break;
                }
                if (profileData.ratingStatusDoubles === 'Projected') {
                    ratingString += ' (P)';
                }
            }
        } else if (profileData.myUtrDoubles > 0) {
            ratingString = `${profileData.myUtrDoubles.toFixed(1)}`;
        }
    }
    return ratingString;
};

export const getMatchTypeIndicator = (rating) => {
    return (
        <React.Fragment>
            <span className="match-type-indicator" />
            {rating.matchType === 'doubles' && (
                <span className="match-type-indicator" />
            )}
        </React.Fragment>
    );
};

export const savedListTypes = {
    players: {
        displayName: 'Players',
        key: 'players',
    },
    schools: {
        displayName: 'Schools',
        key: 'schools',
    },
};

export function newGuid() {
    /* eslint no-bitwise: [2, { allow: ["^","&", ">>"] }] */
    // eslint-disable-next-line no-mixed-operators
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}

export function dictFromArray(arr) {
    const obj = {};
    arr.forEach(el => {
        obj[el.id] = el;
    });
    return obj;
}

export function arraysEqual(_arr1, _arr2) {
    if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) { return false; }

    const arr1 = _arr1.concat().sort();
    const arr2 = _arr2.concat().sort();

    for (let i = 0; i < arr1.length; i += 1) {
        if (arr1[i] !== arr2[i]) { return false; }
    }

    return true;
}

export function findDrawById(draws, selectedDrawId) {
    let draw;

    draws.forEach(drawObj => {
        if (drawObj.id == selectedDrawId) {
            draw = drawObj;
        } else if (drawObj.childDraws && drawObj.childDraws.length) {
            drawObj.childDraws.forEach(childDraw => {
                if (childDraw.id == selectedDrawId) {
                    draw = childDraw;
                }
            });
        }
    });
    return draw;
}

export const getPlayerGradYearOptions = (onlyYearLabel) => {
    const gradYearOptions = [];
    const currentYear = moment().year();
    const isAfterJuly = moment().month() > 6;
    const start = isAfterJuly ? currentYear : currentYear - 1;
    const end = currentYear + 7;
    for (let year = start; year <= end; year += 1) {
        const yearsAway = year - currentYear;
        let classNameLabel = '';
        if (isAfterJuly) {
            switch (yearsAway) {
                case 0:
                    classNameLabel = 'Graduated';
                    break;
                case 1:
                    classNameLabel = 'Senior';
                    break;
                case 2:
                    classNameLabel = 'Junior';
                    break;
                case 3:
                    classNameLabel = 'Sophomore';
                    break;
                case 4:
                    classNameLabel = 'Freshman';
                    break;
                default:
                    classNameLabel = 'Pre-Freshman';
                    break;
            }
        } else {
            switch (yearsAway) {
                case -1:
                    classNameLabel = 'Graduated';
                    break;
                case 0:
                    classNameLabel = 'Senior';
                    break;
                case 1:
                    classNameLabel = 'Junior';
                    break;
                case 2:
                    classNameLabel = 'Sophomore';
                    break;
                case 3:
                    classNameLabel = 'Freshman';
                    break;
                default:
                    classNameLabel = 'Pre-Freshman';
                    break;
            }
        }
        gradYearOptions.push({ id: year, label: onlyYearLabel ? `${year}` : `${year} - ${classNameLabel}` });
    }
    return gradYearOptions;
};

export const getPlayerGradClassNameAbbreviation = (gradClassName) => {
    switch (gradClassName) {
        case 'Freshman':
            return 'Fr';
        case 'Sophomore':
            return 'So';
        case 'Junior':
            return 'Jr';
        case 'Senior':
            return 'Sr';
        default:
            return 'Pre-Fr';
    }
};

export const paginate = (arr, pageSize, pageNumber) => {
    return arr.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
};

export const teamTennisTypeIds = {
    ADULT_TEAM_TENNIS: 1,
    JUNIOR_TEAM_TENNIS: 3,
};
